import * as CorporateListAction from './action';

const initialState = {
    corporateList: [],
    corporateListError: [],
    analystsListSuccess: [],
    analystsListFailure:[],
    selectedCorporates:[],
    selectedCorporatesError:[],
    fetchCorporates:[],
    fetchCorporatesError:[]

}

const UserAccessManagementCorporateListReducer = (state = initialState, action) => {
    switch (action.type) {
        case CorporateListAction.GET_ANALYSTS_LIST_SUCCESS:
            return  state = {
                ...state,
                analystsListSuccess: action.data
            }
        case CorporateListAction.GET_ANALYSTS_LIST_FAILURE:
            return  state = {
                ...state,
                analystsUserListFailure: action.data
            }
        case CorporateListAction.LIST_CORPORATE_SUCCESS:
            return state = {
                ...state,
                corporateList: action.data
            }
        case CorporateListAction.LIST_CORPORATE_FAILURE:
            return state = {
                ...state,
                corporateListError: action.error
            }
        case CorporateListAction.USER_SELECTED_CORPORATES_SUCCESS:
            return state = {
                ...state,
                selectedCorporates: action
            }
        case CorporateListAction.USER_SELECTED_CORPORATES_FAILURE:
            return state = {
                ...state,
                selectedCorporatesError: action
            }
        case CorporateListAction.FETCH_USER_CORPORATES_SUCCESS:
            return state = {
                ...state,
                fetchCorporates: action
            }
        case CorporateListAction.FETCH_USER_CORPORATES_FAILURE:
            return state = {
                ...state,
                fetchCorporatesError: action
            }
            default: return state
        }
    }

    export default UserAccessManagementCorporateListReducer;